module.exports = __webpack_public_path__ + "img/entry_img.98288858.png";